export const enum ItemSendEventReason {
    ExtensibilityUnavailable = 1,
    AllowEventFalse = 2,
    AllowEventTrue = 4,
    FunctionNotFound = 8,
    FunctionTimedOut = 16,
    Unknown = 32,
}
